<ng-container *ngIf="readOnly">
  <img src="./assets/images/shared/read-only.svg"
       class="read-only-image"
       [placement]="placement"
       [tooltip]="tooltip" />
</ng-container>
